import { EventBase } from "@vp/models";
import { IFileUpload } from "../file";

export class UploadFileCompleteEvent extends EventBase<IFileUpload> {
  constructor(private fileSelection: IFileUpload) {
    super();
    this.args = this.fileSelection;
  }
}
